<template>
  <div class="box2">
    <pageTitle
      title="赋能各行业&nbsp;&nbsp;应用领域广"
      text="AI技术辐射实体经济各行各业，商业化前景不可估量"
    />

    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
          :class="'block' + (index + 1)"
        >
          <div class="block">
            <div class="title">{{ item.title }}</div>
            <img
              :src="
                require(`../../../assets/coursePage/ai/box2/icon${
                  index + 1
                }.png`)
              "
              alt
            />
            <div class="tag-box">
              <div class="tag" v-for="i in item.tag" :key="i">{{ i }}</div>
            </div>
          </div>
        </swiper-slide>
        <div class="seat"></div>
      </swiper>
      <!-- <div class="swiper-pagination-box2"></div> -->
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},
  data() {
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
      list: [
        {
          title: "数据挖掘",
          tag: ["数据分析", "行为分析", "用户画像", "金融风控"],
        },
        {
          title: "NLP自然语言处理",
          tag: ["ChatGPT", "聊天翻译", "智能客服", "逻辑推理", "情感分析"],
        },
        {
          title: "CV图像与视觉处理",
          tag: [
            "目标追踪",
            "视觉追踪",
            "场景识别",
            "人脸识别",
            "文字识别",
            "自动驾驶",
          ],
        },
        {
          title: "数据科学",
          tag: ["广告", "搜索", "推荐"],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.box2 {
  padding: 80px 0 88px;
  width: 100%;
  background: #f8feff;
  .subject-content {
    position: relative;
    margin-top: 48px;

    width: 100%;
    box-sizing: border-box;
  }
  .seat {
    width: 32px;
    flex-shrink: 0;
  }
  .swiper-wrapper {
    width: 100%;
  }
  .swiper-slide {
    margin-left: 32px;
    width: 600px;
    height: 280px;

    border-radius: 20px;
    border: solid 2px transparent;
    background: linear-gradient(221deg, #ffebd3 0%, #fffaf5 100%);
    background-image: linear-gradient(221deg, #ffebd3 0%, #fffaf5 100%),
      linear-gradient(to bottom, #ffe2ba, #fef7ef);
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .block {
    position: relative;
    flex-shrink: 0;
    padding: 40px;
    padding-right: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    img {
      position: absolute;
      top: -2px;
      right: -2px;
      width: 136px;
      height: 180px;
    }
    .title {
      margin-bottom: 32px;
      font-size: 32px;
      font-family: PingFangSC-Semibold;

      font-weight: 600;
      color: #1d2129;
      line-height: 48px;
    }

    .tag-box {
      display: flex;
      flex-wrap: wrap;
      .tag {
        position: relative;
        margin-right: 40px;
        margin-bottom: 32px;
        padding-left: 40px;
        box-sizing: border-box;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1d2129;
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 32px;
          height: 32px;
          background: url("../../../assets/coursePage/ai/box2/tag1.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .block2 {
    width: 640px;
    height: 280px;
    border: solid 2px transparent;
    border-radius: 20px;
    background-image: linear-gradient(221deg, #cbfdf7 0%, #e7feff 100%),
      linear-gradient(to bottom, #acfef4, #dffffb);
    background-origin: border-box;
    background-clip: content-box, border-box;
    .block {
      .tag {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 32px;
          height: 32px;
          background: url("../../../assets/coursePage/ai/box2/tag2.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .block3 {
    width: 640px;
    height: 280px;
    border: solid 2px transparent;
    border-radius: 20px;
    background-image: linear-gradient(221deg, #ccefff 0%, #e9fafe 100%),
      linear-gradient(to bottom, #bfecff, #e8f8ff);
    background-origin: border-box;
    background-clip: content-box, border-box;
    .block {
      .tag {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 32px;
          height: 32px;
          background: url("../../../assets/coursePage/ai/box2/tag3.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .block4 {
    border: solid 2px transparent;
    border-radius: 20px;
    background-image: linear-gradient(221deg, #f2efff 0%, #fbfbff 100%),
      linear-gradient(to bottom, #ebe5ff, #f7f7fc);
    background-origin: border-box;
    background-clip: content-box, border-box;
    margin-right: 32px;
    .block {
      .tag {
        &::after {
          content: "";
          position: absolute;
          left: 0;
          width: 32px;
          height: 32px;
          background: url("../../../assets/coursePage/ai/box2/tag4.png")
            no-repeat;
          background-size: cover;
        }
      }
    }
  }

  .swiper-pagination-box2 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }
}
</style>
